// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"606":"6b060e8f","688":"8c64317e","1226":"9ce03058","2327":"a94c34a4","3372":"d068c8cc","5094":"d7bc3e10","5715":"f4e94f85","7058":"3b1ca377","7672":"67549688"}[chunkId] + ".chunk.css";
};